import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  modalContainer: ({ colors }) => css`
    .input-section {
      margin-top: 14px;
      margin-bottom: 20px;
    }
    .highlight {
      color: ${colors.primary[500]};
    }
  `,
  footer: () => css`
    display: flex;
    justify-content: end;

    @media (max-width: 639px) {
      button {
        width: 100%;
      }
    }
  `,
})

export default useStyles
